export const enPatientNoteTranslations = {
  notes: {
    manager: {
      header: '{{name}} Notes',
      templates: {
        title: 'Create a new patient note from a template',
        empty_templates: 'No note templates exists for this organization',
        item: {
          create: 'Create New',
          time: {
            duration: 'Past {{duration}} days',
            aggregated_weekly: 'Aggregated weekly',
            aggregated_monthly: 'Aggregated monthly',
            aggregated_period: 'Aggregated by time periods',
          },
        },
      },
      history: {
        title: 'Notes history',
        name: 'Name',
        created: 'Created',
        data_scope: 'Data scope',
        actions: 'Actions',
        iframe_title: 'PDF for Printing',
      },
    },
    editor: {
      tabs: {
        title: 'Title',
        time: 'Time & Data',
        period: 'Time Period',
        details: 'Patient Details',
        note: 'Note',
        tables: 'Tables',
        trends: 'Trends',
      },
      actions: {
        save: 'Save',
        save_changes: 'Save changes',
        cancel: 'Cancel',
        rename: 'Rename',
        continue_editing: 'Continue editing',
        discard: 'Discard changes',
        copy_to_emr: 'Copy to EMR',
        save_and_sync: 'Save and sync with EMR',
        save_progress_note: 'Save Progress Note',
        download: 'Download',
        sync_to_emr: 'Sync to EMR',
        save_as_template: 'Save as new template',
        save_and_download: 'Save and download',
        back_to_main: 'Back to main view',
      },
      save_popover: {
        title: 'Save patient note',
      },
      back_warning_modal: {
        title: 'Are you sure you want to stop editing this note?',
        description: 'Leaving this page will discard all changes.',
      },
      time_data: {
        baseline: {
          show: 'Show Baseline',
          first_measurement: 'First measurement',
          first_week: 'First week average',
          first_month: 'First month average',
        },
        timeSpan: {
          label: 'Dates',
          description: 'View all data within defined timeframe',
          start: 'Start date',
          end: 'End date',
        },
        agg: {
          label: 'Aggregate by time periods',
          description: 'Compare past weekly/monthly averages',
          weekly: 'Weekly',
          monthly: 'Monthly',
        },
        measurements: {
          label: 'Specific Activities and Clinical Events',
          description: 'Select specific measurements and events',
          instruction: 'Choose up to 10 activities of the same type',
          maxReached: 'You’ve chosen the maximum',
          clear: 'Clear all',
          score: 'Score',
          tags: 'Tags',
          note: 'Note',
        },
      },
      title: {
        placeholder: 'Patient’s Progress Note',
      },
      details: {
        custom_field: 'Add custom field',
        custom_title: 'Field title',
        custom_value: 'Field value',
        validation: 'Title must not be empty or duplicate.',
        fields: {
          name: 'Patient Name',
          dob: 'DOB',
          emr: 'EMR ID',
          sex: 'Sex',
          age: 'Age',
          height: 'Height',
          weight: 'Weight',
          clinician: 'Clinician name',
          facility: 'Facility',
          k_level: 'K level',
          last_fall: 'Last fall',
          total_falls: 'Total falls',
          surgery: 'Surgery type',
          diagnoses: 'Diagnoses',
          mrn: 'MRN',
        },
      },
      note: {
        placeholder: 'Please include your clinical notes here',
      },
      tables: {
        walk: 'Walk',
        passiveRecordings: 'Passive recordings',
        tug: 'Tug',
        sts: 'Sts',
      },
      trends: {
        display: 'Display',
        bar: 'Bar chart',
        scatter: 'Scatter graph',
        unavailable:
          "Unavailable for specific measurements, To view it, click on 'Time and Data' and readjust the timeframe.",
        gait: {
          header: 'Gait {{sum}}',
          showPassiveRecordings: 'Include passive recordings',
          tooltip: {
            passiveRecordings:
              'Passive recordings are shown only if passive walk data exists for the patient within the selected time range',
          },
        },
        fallrisk: { header: 'Fall Risk {{sum}}', item: 'Fall Risk' },
        standard_test: {
          header: 'Standard tests {{sum}}',
          tug: 'Tug',
          tug_turn_time: 'Tug Turn Time',
          sts: 'STS',
          sts_average_angle: 'STS Average Angle',
          sts_average_time_per_repetition: 'STS Average Time per Repetition',
          six_minute_walk: '6 Minute Walk Test',
          two_minute_walk: '2 Minute Walk Test',
        },
        questionnaires: {
          header: 'Questionnaires {{sum}}',
          plusm: 'PlusM',
          amppro: 'AMPPRO',
          lefs: 'LEFS',
          fof: 'Fall confidence (Fear of Falls)',
          psfs: 'PSFS',
          pain_scale: 'Pain Scale',
        },
      },
    },
  },
};
